if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true' || !this.dataset.url) return;

        this.abortController = new AbortController();

        fetch(this.dataset.url, { signal: this.abortController.signal })
          .then((response) => {
            if (!response.ok) throw new Error('Product recommendations could not be loaded');
            return response.text();
          })
          .then((html) => {
            const recommendations = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('product-recommendations');

            if (!recommendations?.innerHTML.trim()) {
              this.hidden = true;
              return;
            }

            this.innerHTML = recommendations.innerHTML;
            this.dataset.loaded = 'true';
          })
          .catch((error) => {
            if (error.name !== 'AbortError') this.hidden = true;
          });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    }
  );
}
